import { render } from "./ChatsFinalizadosView.vue?vue&type=template&id=4f048488&ts=true"
import script from "./ChatsFinalizadosView.vue?vue&type=script&lang=ts"
export * from "./ChatsFinalizadosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__